import dayjs from "utils/config/dayjs.config";

const FormatUtils = {
  vndPrice: (value: any) => {
    if (isNaN(value) || value === null || value === undefined) {
      return "0";
    }
    const validValue = +value;
    return `${new Intl.NumberFormat().format(validValue)} `;
  },
  Price: (value: any) => {
    if (isNaN(value) || value === null || value === undefined) {
      return "0 VNĐ";
    }
    const validValue = +value;
    return `${new Intl.NumberFormat().format(validValue)} VNĐ`;
  },
  DPrice: (value: any) => {
    if (isNaN(value) || value === null || value === undefined) {
      return "0 đ";
    }
    const validValue = +value;
    return `${new Intl.NumberFormat().format(validValue)} Đ`;
  },
  Percent: (value: any) => {
    if (isNaN(value) || value === null || value === undefined) {
      return "0 %";
    }
    const validValue = +value;
    return `${new Intl.NumberFormat().format(validValue)} %`;
  },
  formatDate: (date?: Date | string) => {
    if (!date || !dayjs(date).isValid()) return "";
    return dayjs(date).format("DD/MM/YYYY");
  },
  formatDateTime: (date?: Date | string) => {
    if (!date || !dayjs(date).isValid()) return "";
    return dayjs(date).format("DD/MM - HH:mm:ss");
  },
  formatFullDateTime: (date?: Date | string) => {
    if (!date || !dayjs(date).isValid()) return "";
    return dayjs(date).format("DD/MM/YYYY - HH:mm:ss");
  },
  formatHour: (date?: Date | string) => {
    if (!date || !dayjs(date).isValid()) return "";
    return dayjs(date).format("HH");
  },
  formatTime: (date?: Date | string) => {
    if (!date || !dayjs(date).isValid()) return "";
    return dayjs(date).format("HH:mm:ss");
  },
};

export default FormatUtils;
